/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  CANCEL_POLICY: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.cancel.policy',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CANCEL_POLICY' },
      },
    },
    CANCEL_POLICY: {
      invoke: {
        id: 'cancelPolicy',
        src: 'cancelPolicy',
        onDone: {
          target: 'CANCEL_POLICY_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CANCEL_POLICY_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    CANCEL_POLICY_SUCCESS: {
      on: {
        START: { target: 'CANCEL_POLICY' },
      },
    },
    CANCEL_POLICY_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
